import { getManagerProfileOptions } from '../../../../../../api'
import { EMPTY_LIST } from '../../../../../../constants/common'
import { getItemsFromIdwellApiResponse } from '../../../../../../utils/api'
import { FieldStackedLabel } from '../../../../../Field'
import { FormFieldSelectNG } from '../../../../../Form'
import { FormikField } from '../../../../../Formik'
import {
  toUserSelectItemsFromOption,
  UserMultiSelect,
} from '../../../../../User'

import * as styles from '../../../ConnectedRequestsMassEditModal.module.css'

function ManagersValueField({ label, name, placeholder }) {
  return (
    <FormikField
      multi
      Component={FormFieldSelectNG}
      Field={FieldStackedLabel}
      Select={UserMultiSelect}
      controlProps={{
        contentProps: {
          inputProps: {
            placeholder,
          },
        },
      }}
      emptyValue={EMPTY_LIST}
      fieldComponentProps={{
        className: styles.valueFieldStackedLabel,
        label,
      }}
      getData={getManagerProfileOptions}
      getDataItems={getItemsFromIdwellApiResponse}
      name={name}
      toPreparedItems={toUserSelectItemsFromOption}
    />
  )
}

export default ManagersValueField
